<template lang="pug">
</template>
<script>
export default {
  props:{
    p:{
      type:Object,
      required:true
    },
    angle:{
      type:Number,
      default:0
    },
    container:{
      type:Object,
      required:true
    },
    parent:{
      type:Object,
      required:true
    },
    transform:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    }

  },
  mounted() {
    this.createArrow();
  },
  beforeDestroy() {
    this.arrow.exit();
    //this.editor.addToExitBatch(this.arrow);
  },
  methods:{
    createArrow() {
      if (this.arrow) {
        this.arrow.btn.off('hammertap');
        this.arrow.btn.off('hammerpress');
        this.arrow.btn.off('hammerpressup');
        this.arrow.btn.off('hammerpanstart');
        this.arrow.btn.off('hammerpanend');
        this.arrow.btn.off('hammerpanmove');
        this.arrow.exit();
      }
      this.arrow = new Arrow(this.parent, this.editobjects, this.container, this.parent, 0.5, 0.5, this.p, this.angle);
      this.arrow.btn.on('hammertap', () => {
        this.$emit('hammertap');
      })
      this.arrow.btn.on('hammerpress', () => {
        this.$emit('hammerpress');
      })

      this.arrow.btn.on('hammerpressup', () => {
        this.$emit('hammerpressup');
      })
      this.arrow.events.on('select', (e) => {
        //e.preventDefault();
        this.$emit('select');
      });

      this.arrow.events.on('hammerpanstart', this.onDragStart.bind(this))
        .on('hammerpanend', this.onDragEnd.bind(this))
        .on('hammerpanmove', this.onDragMove.bind(this))

      this.arrow.enter();
      this.arrow.update();
      //this.renderTools.addToEnterBatch(this.arrow);
    },
    onDragStart(event) {
      this.$emit('on-drag-start', event);
    },
    onDragMove(event) {
      //this.editor.addToRunBatch( () => { });
      this.$emit('on-drag-move', event);
    },
    onDragEnd(event) {
      this.$emit('on-drag-end', event);
    }
  },
  computed:{
  },
  watch:{
    'p.x'() {
      this.arrow.point.x = this.p.x;
      this.arrow.update();
    },
    'p.y'() {
      this.arrow.point.y = this.p.y;
      this.arrow.update();
    },
    'angle'() {
      this.arrow.angle = this.angle;
      this.arrow.update();
    },
  }
}


const DEFAULT_ALPHA = 0.8;
import EventEmitter from 'eventemitter3';
function Arrow(parent, editobjects, container, parentHolder, offsetx, offsety, point, angle) {
  this.container = container;
  this.editobjects = editobjects;
  this.point = point;
  this.parentHolder = parentHolder;
  this.color = 0x00ff00;
  this.offsetx = offsetx;
  this.offsety = offsety;
  this.parent = parent;
  this.angle = angle;

  this.width = 16;
  this.height = 16;

  const btn = new PIXI.Graphics();
  this.btn = btn;
  this.created = false;
  this.events = new EventEmitter();
}

Arrow.prototype.drawOverlay = function () {
  this.drawArrow();
}

Arrow.prototype.drawArrow = function () {
  const width = this.width, height = this.height;
  this.btn.clear();
  if (this.pointerDown) {
    this.btn.beginFill(0xB8B8B8);
    this.btn.lineStyle(2, 0xFF6F78);
    this.btn.drawRect(-width/2,-height/2,width,height);
  } else {
    this.btn.beginFill(0x87393E);
    this.btn.lineStyle(2, 0xFF6F78);
    this.btn.drawRect(-width/2,-height/2,width,height);
  }

  this.btn.beginFill(0xFF6F78);
  const x1 = -width/2;
  const x2 = width/2;
  const y1 = -height/2;
  const y2 = height/2;
  this.btn.drawPolygon([
    x1 + 4, y1 + 4,
    x2 - 4, (y1+y2) / 2,
    x1 + 4, y2 - 4
    //(x1+x2)/2, y1 + 4,
    //x2 - 4, y2 - 4,
    //x1 + 4, y2 - 4

  ])

}
Arrow.prototype.enter = function () {
  //this.btn.position.set(globalPos);
  this.btn.scale.x = 1;
  this.btn.scale.y = 1;
  this.btn.alpha = DEFAULT_ALPHA;
  this.btn.rotation = 0;
  this.btn.interactive = true;
  this.btn.hammerIndex = 500;
  this.drawArrow();


  //attach event

  //this.eventEmitter = btn.specialThingy;

  this.container.addChild(this.btn);

  this.created = true;

  this.btn.on('pointerdown', () => {
    this.pointerDown = true;
    this.drawArrow();
  });
  this.btn.on('pointerup', () => {
    this.pointerDown = false;
    this.drawArrow();
  })
  this.btn.on('pointerupoutside', () => {
    this.pointerDown = false;
    this.drawArrow();
  })

  this.btn.on('hammerpanstart', (e) => {
      this.pointerDown = true;
      this.drawArrow();
      this.events.emit('hammerpanstart', e);
    })
    .on('hammerpanend', (e) => {
      this.pointerDown = false;
      this.drawArrow();
      this.events.emit('hammerpanend', e);
    })
    .on('hammerpanmove', (e) => {
      this.events.emit('hammerpanmove', e);
    })
}

Arrow.prototype.fixPoint = function (p) {
  return {
    x:p.x + this.container.pivot.x,
    y:p.y + this.container.pivot.y

  }
}

Arrow.prototype.update = function () {
  if (!this.created) {
    this.enter();
  }
 const localPos = {
    x:this.point.x + this.offsetx - 0.5,
    y:this.point.y + this.offsety - 0.5
  }

  const fokkenBounds = this.parentHolder.getGlobalBounds();

  const width = Math.max(
    Math.abs(fokkenBounds.p3.x - fokkenBounds.p1.x),
    Math.abs(fokkenBounds.p4.x - fokkenBounds.p2.x)
  )
  const height = Math.max(
    Math.abs(fokkenBounds.p3.y - fokkenBounds.p1.y),
    Math.abs(fokkenBounds.p4.y - fokkenBounds.p2.y)
  )

  const fokkenPos = {
    x:(fokkenBounds.p1.x + fokkenBounds.p3.x)/2 + localPos.x * width,
    y:(fokkenBounds.p1.y + fokkenBounds.p3.y)/2 + localPos.y * height
  }
  const globalPos = this.fixPoint(this.parentHolder.getGlobalPoint(localPos));
  const centerPos = this.fixPoint(this.parentHolder.getGlobalPoint({x:0,y:0}));

  const angle = Math.atan2(-this.offsety, -this.offsetx);

  //this.btn.position.x = globalPos.x + Math.cos(angle)*20;
  //this.btn.position.y = globalPos.y + Math.sin(angle)*20;

  this.btn.position.x = fokkenPos.x + Math.cos(this.angle)*this.width/2;
  this.btn.position.y = fokkenPos.y + Math.sin(this.angle)*this.height/2;

  this.btn.rotation = this.angle;

  this.btn.pivot.x = 0.5;
  this.btn.pivot.y = 0.5;
}

Arrow.prototype.exit = function () {

  this.container.removeChild(this.btn);
  this.arrows = [];
}


</script>
